import { CS } from "../../../../base/utils/styler";

export const nameTdStyle: CS = {
    textAlign: 'right',
    width: '200px'
}